import AddIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Settings';
import * as theme from '../theme';

export default function Heading(props) {
  const headingTheme = props.subHeading ? theme.SubHeading : theme.Heading;

  const pillStyle = {
    backgroundColor: theme.Colors.Gold,
    color: theme.Colors.GrayDark,
    padding: '2px 10px',
    borderRadius: 12,
    marginLeft: 10,
    fontSize: '0.6em',
    alignSelf: 'center',
  };

  return (
    <div style={{ display: 'flex', flex: 1, paddingLeft: 10, paddingRight: 10, paddingTop: props.addMargin ? 20 : 10, paddingBottom: 10, justifyContent: props.center ? 'center' : 'start' }}>
      {props.title &&
        <div 
          style={{ 
            ...headingTheme,
            color: props.color ? props.color : props.lightColor ? theme.Colors.GrayMedium : theme.Colors.GrayDark, 
            paddingTop: props.subHeading ? 7 : 5, 
            paddingBottom: props.subHeading ? 8 : 5,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: props.icon ? '100%' : 'auto'
          }}
        >
          <div style={{ display: 'flex', flex: '2 0 0', cursor: props.onClick ? 'pointer' : 'auto' }} onClick={() => props.onClick ? props.onClick() : null}>
            {props.subHeading ? props.title : props.title.toUpperCase()}
            {props.subTitle && <span style={{ color: theme.Colors.GrayMedium, paddingLeft: 5 }}> ({props.subTitle})</span>}
            {props.subData && <span style={{ color: theme.Colors.GrayMedDark, fontSize: '0.9em', paddingLeft: 50 }}> {props.subData}</span>}
            {props.subData2 && <span style={{ color: theme.Colors.GrayMedDark, fontSize: '0.9em', paddingLeft: 50 }}> {props.subData2}</span>}
            {props.immediateFamily && <div style={pillStyle}>Family</div>}
          </div>
          <div style={{ display: 'flex', flex: '0', justifyContent: 'flex-end', minHeight: 28 }}>
            {props.icon && (props.icon === 'edit') &&
              <EditIcon className={'link-icon'}  sx={{ fontSize: 28 }} onClick={() => props.iconAction()} />
            }
            {props.icon && (props.icon === 'add' || props.icon === 'both') &&
              <AddIcon className={'link-icon'} sx={{ fontSize: 28 }} onClick={() => props.iconAction()} />
            }
          </div>
        </div>
      }
    </div>
  );
}